$(document).ready(function() {
    var tyreRackBXSlider;
    var $tyreRackCarousel = $("#tyre-rack--carousel");
    var $tyreRackCarouselContainer = $("#tyre-rack-carousel");
    var $tyreRackCarouselSlider = $(".tyre-rack-carousel");

    $tyreRackCarousel.find(".tyre-rack--menu-link").on('click', function(event) {
        var index = $(this).data("index");
        var $carousel = $("#tyre-rack--carousel");

        $carousel.find(".tyre-rack--list-item").removeClass("active");
        $carousel.find("#tyre-rack--list-item-" + index).addClass("active");

        if (typeof tyreRackBXSlider !== 'undefined') {
            tyreRackBXSlider.destroySlider();
        }

        tyreRackBXSlider = $tyreRackCarousel.find('.tyre-rack--slider-' + index).bxSlider({
            mode: 'vertical',
            pager: false,
            touchEnabled: false,
            minSlides: 3,
            maxSlides: 3,
            slideMargin: 20,
            prevSelector: "#tyre-rack--slider-prev-" + index,
            nextSelector: "#tyre-rack--slider-next-" + index,
            prevText: '<i class="fa fa-chevron-up"></i>',
            nextText: '<i class="fa fa-chevron-down"></i>'
        });

        event.preventDefault();
    });

    $tyreRackCarousel.find(".tyre-rack--menu-link:first").trigger('click');
	
    if ($tyreRackCarouselContainer.length && $tyreRackCarouselSlider.length) {

        $tyreRackCarouselContainer.show();

        var sliders = $tyreRackCarouselSlider.bxSlider({
			mode: 'horizontal',
			slideWidth: 'auto',
			minSlides: 8,
			maxSlides: 10,
			slideMargin: 20,
			controls: true,
			pager: false,
			moveSlides: '1',
			autoStart: false,
			hideControlOnEnd: true,
			shrinkItems: true,
			auto: false,
			prevSelector: "#tyre-rack--slider-prev",
			nextSelector: "#tyre-rack--slider-next",
			prevText: '<i class="fa fa-chevron-left"></i>',
			nextText: '<i class="fa fa-chevron-right"></i>'
		});

        var selectedSlide = Math.floor(Math.random() * sliders.getSlideCount());
        displayTyreRackCarouselElementAt(selectedSlide, 'bannersSlide-bottom', 'tyrerack-carousel-pagination-element');
        sliders.goToSlide(selectedSlide);
    }
});

function displayTyreRackCarouselElementAt(position, elementsClass, buttonsClass) {
    var elements = $("." + elementsClass);
    var buttons = $("." + buttonsClass);

    $(elements).hide();
    $(buttons).removeClass("selected");
    $("#" + elementsClass + position).show();
    $("." + buttonsClass + position).addClass("selected");
}
